<template>
  <div class="aside-container">
    <el-row>
      <el-col :span="24">
        <el-menu
          default-active="2"
          :default-openeds="defaultOpenedMenus"
          text-color="#606266"
          active-text-color="#D04247"
          router
          @select="clickAsideNav"
        >
          <div v-for="menu in asideTabMenu" :key="menu.id">
            <el-menu-item :index="menu.path" v-if="!menu.children && !isFinanceMenu(menu.title)">
              {{ menu.title }}
            </el-menu-item>
            <el-submenu :index="menu.path" v-else-if="menu.children">
              <template slot="title">{{ menu.title }}</template>
              <div v-for="menuChidren in (menu.childrenArray || Object.values(menu.children))" :key="menuChidren.id">
                <el-menu-item
                  :index="menuChidren.path"
                  v-if="!menuChidren.children"
                >
                  {{ menuChidren.title }}
                </el-menu-item>
                <el-submenu :index="menuChidren.path" v-if="menuChidren.list">
                  <template slot="title">{{ menuChidren.title }}</template>
                  <el-menu-item
                    :index="menuChidrenItem.path"
                    v-for="menuChidrenItem in menuChidren.children"
                    :key="menuChidrenItem.id"
                  >
                    {{ menuChidrenItem.title }}
                  </el-menu-item>
                </el-submenu>
              </div>
            </el-submenu>
            <!-- Force finance menus to be submenu for expansion -->
            <el-submenu :index="menu.path" v-else-if="isFinanceMenu(menu.title)">
              <template slot="title">{{ menu.title }}</template>
              <el-menu-item :index="menu.path">
                {{ menu.title }}
              </el-menu-item>
            </el-submenu>
          </div>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'NavAside',
  methods: {
    ...mapMutations('m_tabs', ['changeRoutePath']),
    clickAsideNav(index) {
      this.changeRoutePath(index)
      console.log(index);

    },
    isFinanceMenu(title) {
      return title === '办案费用' || 
             title === '日常费用' || 
             title === '退案列表' || 
             title === '结案归档'
    }
  },
  computed: {
    ...mapState('m_tabs', ['asideTabMenu']),
    defaultOpenedMenus() {
      const openedMenus = []
      // Find the 诉讼在办 menu and add it to openedMenus
      this.asideTabMenu.forEach(menu => {
        if (menu.title === '诉讼在办') {
          openedMenus.push(menu.path)
        }
        // Also expand all finance-related menus since they don't have children structure
        if (menu.title === '办案费用' || menu.title === '日常费用' || 
            menu.title === '退案列表' || menu.title === '结案归档') {
          openedMenus.push(menu.path)
        }
      })
      return openedMenus
    }
  },
  }
</script>

<style lang="scss" scoped>
.aside-container {
  height: 100vh;
}
</style>
